import { Controller } from "@hotwired/stimulus"

// Limita la cantidad de prestaciones en la orden de servicio.
export default class extends Controller {
  static targets = ["addButton", "count"]

  static values = {
    max: { type: Number, default: 0 },
    wrapperSelector: { type: String, default: ".imagen-prestaciones-form-wrapper" }
  }

  connect() {
    this.refreshQueued = false
    this.observer = new MutationObserver(() => this.queueRefresh())
    this.observer.observe(this.element, { childList: true, subtree: true })
    this.refresh()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }

    this.refreshQueued = false
  }

  queueRefresh() {
    if (this.refreshQueued) return

    this.refreshQueued = true
    requestAnimationFrame(() => {
      this.refreshQueued = false
      this.refresh()
    })
  }

  refresh() {
    const count = this.currentCount()

    if (this.hasCountTarget) {
      const nextCount = `${count}`
      if (this.countTarget.textContent !== nextCount) {
        this.countTarget.textContent = nextCount
      }
    }

    if (this.hasAddButtonTarget) {
      const reached = this.maxValue > 0 && count >= this.maxValue
      const nextTitle = reached
        ? `Solo se permiten ${this.maxValue} prestaciones por orden`
        : ""

      if (this.addButtonTarget.disabled !== reached) {
        this.addButtonTarget.disabled = reached
      }

      if (this.addButtonTarget.title !== nextTitle) {
        this.addButtonTarget.title = nextTitle
      }
    }
  }

  currentCount() {
    const wrappers = Array.from(this.element.querySelectorAll(this.wrapperSelectorValue))

    return wrappers.filter((wrapper) => {
      const destroyInput = wrapper.querySelector('input[name*="[_destroy]"]')
      const markedForDestroy = destroyInput && destroyInput.value === "1"
      const hidden = wrapper.hidden || wrapper.classList.contains("d-none") || wrapper.offsetParent === null

      return !markedForDestroy && !hidden
    }).length
  }
}
